export default "__VITE_ASSET__ttN238Qo__"